import SelectFilterModal from './SelectFilterModal'
import useTrenerFilterModal from '../hooks/useTrenerFilterModal'

export default function TrenerFilterModal({
	isOpen,
	onClose,
	selectedTrainerId,
	onApply,
	title = 'Filtruj po trenerze',
	description = 'Wybierz trenera, aby zawezic liste szkolen.',
	applyLabel = 'Zastosuj',
	clearLabel = 'Wyczysc filtr',
}) {
	const state = useTrenerFilterModal(isOpen, selectedTrainerId)
	return (
		<SelectFilterModal
			isOpen={isOpen}
			onClose={onClose}
			onApply={onApply}
			title={title}
			description={description}
			placeholder="Szukaj trenera po nazwie, miescie lub certyfikacie..."
			emptyMessage="Nie znaleziono trenerow"
			applyLabel={applyLabel}
			clearLabel={clearLabel}
			{...state}
		/>
	)
}
